<template class="pageUser">
  <div class="page-user">
    <!--modal-->
    <!--      <b-button @click="show=true" variant="primary" class="custom">Show Modal</b-button>-->
    <b-modal centered
             class="custom modul"
             v-model="show"
             title="Czy na pewno chcesz anulować?">
      <!--

              -->
      <template slot="modal-header">
        <h5 class="modal-title">Czy na pewno chcesz anulować?</h5>
        <button type="button" aria-label="Close" class="close" @click="show=false">
          <span class="icon icon-close_small"></span>
        </button>
      </template>

      <div slot="modal-footer" class="w-100">
        <div class="row">
          <div class="col-12 col-md-10 col-lg-6">
            <b-button
              variant="secondary"
              size="lg"
              class="custom"
              block

              @click="show=false"
            >
              Anuluj
            </b-button>

          </div>
          <div class="col-12 col-md-10 col-lg-6">
            <b-button
              variant="danger"
              size="lg"
              class="custom"
              block
              @click="show=false"
            >
              Tak
            </b-button>

          </div>
        </div>
      </div>
    </b-modal>
    <!--end modal-->
    <div class="row justify-content-center mt-2">
      <div class="col-12 col-md-10 col-lg-6">
        <div class="step-box  ">
          <div class="step-container active ">
            <span class="step step-first d-block"></span>
            <p>Role użytkownika</p>
          </div>
          <div class="step-container">
            <span class="step step-two d-block"></span>
            <p>Dane użytkownika</p>
          </div>
          <div class="step-container">
            <span class="step step-tree d-block"></span>
            <p>Uprawnienia</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-6">
        <b-card class="card-add custom">
          <template slot="header">
            <h2>Role użytkownika</h2>
          </template>
          <b-card-text>
            <b-form-radio-group>

              <div class="row justify-content-between">
                <div class="col-12 col-md-10 col-lg-6">
                  <b-form-radio v-model="selected" name="some-radios" value="A" class="">Master
                    Admin
                  </b-form-radio>
                </div>
                <div class="col-12 col-md-10 col-lg-6">
                  <b-form-radio v-model="selected" name="some-radios" value="D" class="">Admin
                  </b-form-radio>

                </div>
              </div>
              <div class="row justify-content-between">
                <div class="col-12 col-md-10 col-lg-6">
                  <b-form-radio v-model="selected" name="some-radios" value="B" class="">Central
                    Manager
                  </b-form-radio>
                </div>
                <div class="col-12 col-md-10 col-lg-6">
                  <b-form-radio v-model="selected" name="some-radios" value="E" class="">
                    Regional Manager
                  </b-form-radio>
                </div>
              </div>
              <div class="row justify-content-between">
                <div class="col-12 col-md-10 col-lg-6">
                  <b-form-radio v-model="selected" name="some-radios" value="C" class="">Unit
                    Manager
                  </b-form-radio>
                </div>
                <div class="col-12 col-md-10 col-lg-6">
                  <b-form-radio v-model="selected" name="some-radios" value="F" class="">
                    Accounts
                  </b-form-radio>
                </div>
              </div>

            </b-form-radio-group>

          </b-card-text>
          <template slot="footer">

          </template>
        </b-card>
      </div>

    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-6 ">
        <div class="row justify-content-between">
          <div class="col-4 d-flex">
            <b-link class="custom btn-link align-self-center ml-3"
                    @click="show=true"
            >{{$t('Anuluj')}}
            </b-link>

          </div>
          <div class="col-4 pr-2">
            <b-button
              variant="secondary"
              class="custom"
              block
            >{{$t('Wróć')}}
            </b-button>

          </div>
          <div class="col-4 pl-2">
            <b-button variant="primary" class="custom" block>{{$t('Dalej')}}</b-button>
          </div>

        </div>

      </div>

    </div>


    <!--page-step2-->
    <div class="row justify-content-center  mt-3">
      <div class="col-12 col-md-10 col-lg-6">
        <div class="step-box  ">
          <div class="step-container completed ">
            <span class="step step-first d-block"></span>
            <p>Role użytkownika</p>
          </div>
          <div class="step-container active ">
            <span class="step step-two d-block"></span>
            <p>Dane użytkownika</p>
          </div>
          <div class="step-container">
            <span class="step step-tree d-block"></span>
            <p>Uprawnienia</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-6">
        <b-card class="card-add custom">
          <template slot="header">
            <h2>Dane użytkownika</h2>
          </template>
          <b-card-text>
            <div class="form-group custom mb-0">
              <label for="input1"><span>* </span>Imię</label>
              <b-form-input id="input1" size="lg"
                            placeholder="Enter your name"
                            class="custom"
              ></b-form-input>
              <!---->
              <label for="input2"><span>* </span>Nazwisko</label>
              <b-form-input id="input2" size="lg"
                            placeholder="Enter your name"
                            class="custom"
              ></b-form-input>
              <!---->
              <label for="input3">Stanowisko</label>
              <b-form-input id="input3" size="lg"
                            placeholder="Enter your name"
                            class="custom"
              ></b-form-input>
              <!---->

              <label for="tel-kon">Telefon Komórkowy</label>
              <div class="input-group input-select custom lg">
                <div class="input-group-prepend">
                  <button class="btn btn-outline-secondary dropdown-toggle custom"
                          type="button" data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false">+XX
                  </button>
                  <div class="dropdown-menu">
                    <a class="dropdown-item" href="#">1</a>
                    <a class="dropdown-item" href="#">2</a>
                    <a class="dropdown-item" href="#">3</a>
                    <a class="dropdown-item" href="#">4</a>
                  </div>
                </div>
                <input type="text" class="form-control" id="tel-kon"
                       aria-label="Text input with dropdown button">
              </div>
              <label for="tel-st">Telefon Stacjonarny</label>
              <div class="input-group input-select custom  lg">
                <div class="input-group-prepend">
                  <button class="btn btn-outline-secondary dropdown-toggle custom"
                          type="button" data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false">+XX
                  </button>
                  <div class="dropdown-menu">
                    <a class="dropdown-item" href="#">1</a>
                    <a class="dropdown-item" href="#">2</a>
                    <a class="dropdown-item" href="#">3</a>
                    <a class="dropdown-item" href="#">4</a>
                  </div>
                </div>
                <input type="text" class="form-control" id="tel-st" placeholder="Numer"
                       aria-label="Text input with dropdown button">
              </div>

              <!---->

              <label for="input4"><span>* </span>E-mail</label>
              <b-form-input id="input4" size="lg"
                            placeholder=""
                            class="custom"
              ></b-form-input>

              <!--                <treeselect v-model="value" :multiple="true" :options="options" class="custom"/>-->
              <label for="input5"><span>* </span>Język Systemu</label>

              <treeselect v-model="value" id="input5"
                          :options="options" class="custom" />
            </div>
          </b-card-text>
          <template slot="footer">

          </template>
        </b-card>
      </div>

    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-6 ">
        <div class="row justify-content-between">
          <div class="col-4 d-flex">
            <b-link class="custom btn-link align-self-center ml-3"
                    @click="show=true"
            >{{$t('Anuluj')}}
            </b-link>

          </div>
          <div class="col-4 pr-2">
            <b-button
              variant="secondary"
              class="custom"
              block
            >{{$t('Wróć')}}
            </b-button>

          </div>
          <div class="col-4 pl-2">
            <b-button variant="primary" class="custom" block>{{$t('Dalej')}}</b-button>
          </div>

        </div>

      </div>

    </div>
    <!--end page-step2-->
    <!--page-step3-->
    <div class="row justify-content-center mt-5">
      <div class="col-12 col-md-10 col-lg-6">
        <div class="step-box  ">
          <div class="step-container completed ">
            <span class="step step-first d-block"></span>
            <p>Role użytkownika</p>
          </div>
          <div class="step-container  completed">
            <span class="step step-two d-block"></span>
            <p>Dane użytkownika</p>
          </div>
          <div class="step-container  active">
            <span class="step step-tree d-block"></span>
            <p>Uprawnienia</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-6">
        <b-card class="card-add table custom ">
          <template slot="header">
            <h2>Uprawnienia <span class="icon icon-info "></span></h2>
          </template>
          <b-table striped :fields="fields" :items="items">
            <template slot="radioValue" slot-scope="scope">
              <b-form-radio-group>
                <div class="row justify-content-between" v-if="scope.index === 4">
                  <div class="col-12 col-md-10 col-lg-4">
                    <b-form-radio v-model="items[scope.index].radioValue" name="some-radios" value="Dostęp"
                                  class="">Dostęp
                    </b-form-radio>
                  </div>
                </div>
                <div class="row justify-content-between" v-else-if="scope.index === 7">
                  <div class="col-12 col-md-10 col-lg-6">
                    <b-form-radio v-model="items[scope.index].radioValue" name="some-radios"
                                  value="Ograniczony zakres" class="">Ograniczony zakres
                    </b-form-radio>
                  </div>
                  <div class="col-12 col-md-10 col-lg-6">
                    <b-form-radio v-model="items[scope.index].radioValue" name="some-radios" value="Pełny zakres"
                                  class="">Pełny zakres
                    </b-form-radio>
                  </div>
                </div>
                <div class="row justify-content-between" v-else>
                  <div class="col-12 col-md-10 col-lg-4">
                    <b-form-radio v-model="items[scope.index].radioValue" name="some-radios" value="Podgląd"
                                  class="">Podgląd
                    </b-form-radio>
                  </div>
                  <div class="col-12 col-md-10 col-lg-4">
                    <b-form-radio v-model="items[scope.index].radioValue" name="some-radios" value="Edycja"
                                  class="">Edycja
                    </b-form-radio>
                  </div>
                  <div class="col-12 col-md-10 col-lg-4">
                    <b-form-radio v-model="items[scope.index].radioValue" name="some-radios" value="Usuwanie"
                                  class="">Usuwanie
                    </b-form-radio>
                  </div>
                </div>
              </b-form-radio-group>
            </template>
          </b-table>

          <template slot="footer">

          </template>
        </b-card>
      </div>

    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-6 ">
        <div class="row justify-content-between">
          <div class="col-4 d-flex">
            <b-link class="custom btn-link align-self-center ml-3"
                    @click="show=true"
            >{{$t('Anuluj')}}
            </b-link>

          </div>
          <div class="col-4 pr-2">
            <b-button
              variant="secondary"
              class="custom"
              block
            >{{$t('Wróć')}}
            </b-button>

          </div>
          <div class="col-4 pl-2">
            <b-button variant="primary" class="custom" block>{{$t('Dalej')}}</b-button>
          </div>

        </div>

      </div>

    </div>
    <!--end page-step3-->

  </div>
</template>

<script>


  // import the component
  import Treeselect from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'UserAdd',

    data () {
      return {
        selected:false,
        value:false,
        time1: '',
        items: [
          { title: 'Firmy', radioValue: 'Dostęp' },
          { title: 'Placówki ', radioValue: '' },
          { title: 'Urządzenia ', radioValue: '' },
          { title: 'Użytkownicy ', radioValue: '' },
          { title: 'Raporty ', radioValue: '' },
          { title: 'Faktury ', radioValue: '' },
          { title: 'Alerty  ', radioValue: '' },
          { title: 'Administracja ', radioValue: '' }
        ],
        fields: [
          { key: 'title', label: '' },
          { key: 'radioValue', label: '' }
        ],
        show: false,
        radioCardFirstSelected: [], // Must be an array reference!
        radioCardFirstOptions: [
          { text: 'Master Admin', value: 'first' },
          { text: 'Central Manager', value: 'two' },
          { text: 'Unit Manager', value: 'tree' },
          { text: 'Admin', value: 'tree1' },
          { text: 'Regional Manager', value: 'tree2' },
          { text: 'Accounts', value: 'tree4' }
        ],
        // treeselect
        // define default value
        // value: null,
        // define options
        options: [{
          id: 'a',
          label: 'a'
        }, {
          id: 'b',
          label: 'b'
        }, {
          id: 'c',
          label: 'c'
        }]
        // treeselect
      }
    },
    components: { Treeselect, DatePicker },
    mixins: [],
    computed: {},
    methods: {
      logout () {
        this.$store.dispatch('logout').then(() => {
          this.$router.push('/login')
        })
      }
    }
  }
</script>

<style scoped>

</style>
